var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Service, { inject as service } from '@ember/service';
import { validateDate } from '@fabscale/ember-fabscale-analytics/utils/validate-date';
import { assert } from '@ember/debug';
import { timeout, dropTask } from 'ember-concurrency';
import { taskFor } from 'ember-concurrency-ts';
import { makeApiRequest } from '../utils/make-api-request';
import { isDevelopingApp, isTesting, macroCondition } from '@embroider/macros';
let AnalyticsWriteService = (_class = class AnalyticsWriteService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "analyticsConfig", _descriptor, this);
    _defineProperty(this, "_queue", []);
    _defineProperty(this, "_debounceTime", 1);
  }
  // Overwrite this if you want to have default properies to add to all events
  get defaultStringProperties() {
    return undefined;
  }

  // Overwrite this if you want to have default properies to add to all events
  get defaultNumericProperties() {
    return undefined;
  }
  get cannotWrite() {
    // In production, we assume that a writeKey is mandatory, to catch missing .env variables
    return macroCondition(isDevelopingApp() || isTesting()) ? !this.analyticsConfig.writeKey : false;
  }
  willDestroy() {
    // try to send the queued events before this is destroyed
    this.createEvents(this._queue);
    this._queue = [];
  }

  // Most of the time, just use this
  // This automatically debounces the creation in the background
  addEvent(eventOptions, properties) {
    if (this.cannotWrite) {
      return;
    }
    let name = typeof eventOptions === 'string' ? eventOptions : eventOptions.name;
    let recordedDate = typeof eventOptions !== 'string' ? eventOptions.recordedDate : undefined;
    let variables = this.makeEventItem({
      name,
      recordedDate
    }, properties);
    this._queue.push(variables);
    taskFor(this.debounceCreateEventsTask).perform();
  }
  *debounceCreateEventsTask() {
    yield timeout(this._debounceTime);
    this.createEvents(this._queue);
    this._queue = [];
  }

  // Immediately create events
  createEvents(events) {
    if (this.cannotWrite) {
      return;
    }
    if (events.length === 0) {
      return;
    }
    assert('createEvents: You have to pass an array of events', Array.isArray(events));
    assert('createEvents: You have to pass an array of events with valid data', !events.some(event => !event.name || !event.recordedDate));
    this._sendEvents(events);
  }
  _sendEvents(events) {
    let {
      apiUrl,
      writeKey
    } = this.analyticsConfig;
    let url = writeKey ? `${apiUrl}?accessToken=${writeKey}` : apiUrl;
    let query = `mutation cme($events: [EventInput!]!) {
  createMultipleEvents(events: $events) { id }
}`;
    let variables = {
      events
    };
    let body = JSON.stringify({
      query,
      variables
    });
    makeApiRequest({
      url,
      body
    });
  }
  makeEventItem({
    name,
    recordedDate
  }, eventProperties = []) {
    if (recordedDate) {
      validateDate(recordedDate);
    } else {
      recordedDate = new Date().toISOString();
    }
    assert('createEvent: You must specify a name', !!name);
    let numericProperties = eventProperties.filter(isNumericProperty);
    let stringProperties = eventProperties.filter(isStringProperty);
    if (this.defaultStringProperties) {
      stringProperties = (stringProperties || []).concat(this.defaultStringProperties);
    }
    if (this.defaultNumericProperties) {
      numericProperties = (numericProperties || []).concat(this.defaultNumericProperties);
    }
    return {
      name,
      recordedDate,
      stringProperties,
      numericProperties
    };
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "analyticsConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "debounceCreateEventsTask", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "debounceCreateEventsTask"), _class.prototype)), _class);
export { AnalyticsWriteService as default };
function isStringProperty(property) {
  return typeof property.value === 'string';
}
function isNumericProperty(property) {
  return typeof property.value === 'number';
}